<template>
  <collapse-default id="transporte">
    <template v-slot:header>
      Transporte de Registro {{ propData.registro_id ? '' : '- Não informado' }}
    </template>

    <template v-slot:content>
      <div v-if="propData"
           class="mt-3 pl-3 pr-3 pb-2">
        <div class="row mt-2">
          <div class="col-2">
            <label class="resumo-show_label"
                   for="">Data do Transporte</label>
            <div class="resumo-show_sublabel">
              {{ propData.data_transporte | date }}
            </div>
          </div>
          <div class="col-2">
            <label class="resumo-show_label"
                   for="">Acervo</label>
            <div class="resumo-show_sublabel">
              {{ propData.acervo || 'Não informado' }}
            </div>
          </div>
          <div class="col-2">
            <label class="resumo-show_label"
                   for="">Livro</label>
            <div class="resumo-show_sublabel">
              {{ propData.livro || 'Não informado' }}
            </div>
          </div>
          <div class="col-2">
            <label class="resumo-show_label"
                   for="">Folha</label>
            <div class="resumo-show_sublabel">
              {{ propData.folha || 'Não informado' }}
            </div>
          </div>
          <div class="col-2">
            <label class="resumo-show_label"
                   for="">Lado</label>
            <div class="resumo-show_sublabel">
              {{ propData.lado || 'Não informado' }}
            </div>
          </div>
        </div>
      </div>
    </template>
  </collapse-default>
</template>

<script>
  import CollapseDefault from "./CollapseDefault"

  export default {
    name: "TransporteCollapse",
    components: {
      CollapseDefault
    },
    props: {
      propData: Object
    }
  }
</script>

<style scoped>

</style>
